import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { PollService } from '../../services/poll.service';
import { PollComponent } from '../poll/poll.component';
import { MdDialog, MdDialogRef } from '@angular/material';
import { PaginatedPolls, Poll, Item } from '../../models/poll';
import { ConfirmDeleteDialogComponent } from '../confirm-delete-dialog/confirm-delete-dialog.component';
import { MessageBoxDialog } from '../message-box/message-box.component';

@Component({
  selector: 'app-view-poll',
  templateUrl: './view-poll.component.html',
  styleUrls: ['./view-poll.component.css']
})
export class ViewPollComponent implements OnInit {

  polls: Poll[];
  loading: boolean;

  page: number;
  total: number;
  max: number;

  selectedOption: string;
  errorMessage: string;

  constructor(private pollService: PollService, public dialog: MdDialog) {
    this.loading = true;
    this.page = 1;
    this.total = 0;
    this.max = 5;
  }

  ngOnInit() {
    this.searchPolls();
  }

  openDialog (name, id) {
      let dialogRef = this.dialog.open(PollComponent);
      dialogRef.afterClosed().subscribe(result => {
        this.selectedOption = result;
        this.searchPolls(this.page);
      });
      dialogRef.componentInstance.nameComponent=name;
      dialogRef.componentInstance.PollID=id;
      dialogRef.componentInstance.Polls=this.polls;
  }

  searchPolls (page?: number, query?: string, active?: boolean, deleted?: boolean) {
    this.loading = true;
    const status = [];

    this.page = page;
    if (page == null) {
      page = 1;
    }

    if (active) {
        status.push('1');
    }

    if (deleted) {
        status.push('-6');
    }

    this.pollService.getPolls2(page, this.max, 0, query, status)
    .subscribe(
    data => {
      this.polls = data.polls;
      this.total = data.pagination.total;
      this.loading = false;
    },
    error => {
      if (error.status == 404) {
        this.polls = undefined;
        this.loading = false;
      } else {
        console.log(error);
        this.polls = undefined;
        this.loading = false;
      }
    });
  }

  onPageChange(page) {
    this.searchPolls (page);
  }

  openDialogDelete(id) {
      const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent);
      dialogRef.componentInstance.deletePoll = true;
      dialogRef.componentInstance.PollID = id;
      dialogRef.componentInstance.PollStatus = -6;
      dialogRef.afterClosed().subscribe(result => {
        this.searchPolls (this.page);
      });
  }

  getTypeName(id) {
    if (id === 1) {
      return 'Selección Simple (S/N)';
    } else if (id === 2) {
      return 'Texto (Máx 140 caractéres)';
    } else if (id === 3) {
      return 'Selección Simple (A,B,C,D)';
    } else if (id === 4) {
      return 'Selección Multiple (A,B,C,D)';
    } else {
      return 'Desconocido';
    }
  }

  showInformation() {
    this.dialog.open(MessageBoxDialog, {data: {message: 'Crea Encuestas para asociarlos a tus ofertas y que tus postulados respondan a través de nuestros robots inteligentes.', inpollation: true, showIcon: true}});
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/view-poll/view-poll.component.ts